import { AcademicLevel, Accompagnateurs, Availabilities, CampaignId, Campus, Consentement, Email, FirstName, LastName, MobilePhoneRequired, SlotId } from "services/validation"
import * as Yup from "yup"

const schema = Yup.object().shape({
  ...Accompagnateurs,
  ...Availabilities,
  ...CampaignId,
  ...Consentement,
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Campus,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
  }),
  ...SlotId
})

export default schema
